'use client'
import classNames from 'classnames'
import Image from 'next/image'
import { type FC, useState } from 'react'
import { whyGlovoContent } from './content/WhyGlovoContent'
import styles from './WhyGlovoContainer.module.scss'
import { Translator } from '@/tools/i18n'
import { useLocalisation } from '@/tools/i18n/client'
import { redirectToCityPage } from '@/tools/migration-helpers/execute-action'
import { Button, HighlightText } from '@/tools/ui'
import { AddressBookModal } from '@/user/address-book/ui/AddressBookModal'

export const WhyGlovoContainer: FC = () => {
  const { t } = useLocalisation()
  const [isOpenAddressBook, setIsOpenAddressBook] = useState(false)

  const handleOpenAddressBook = () => {
    setIsOpenAddressBook(true)
  }

  const handleCloseAddressBook = () => {
    setIsOpenAddressBook(false)
  }

  const handleAddressSelect = async () => {
    await redirectToCityPage()
  }

  return (
    <article className={styles.wrapper}>
      <h1 className={classNames(styles.mainTitle, 'pintxo-typography-feature3')}>
        {t('why-glovo.title')}
      </h1>
      <section className={styles.container}>
        {whyGlovoContent.map((box) => (
          <div key={box.titleKey} className={styles.box}>
            <Image alt={box.titleKey} height={140} src={box.imageId} width={170} />
            <p className={classNames(styles.title, 'pintxo-typography-title3')}>
              {t(`${box.titleKey}`)}
            </p>
            <div className={styles.description}>
              <Translator
                keyText={box.descriptionKey}
                params={{
                  highlight: (
                    <HighlightText
                      color={'brand'}
                      size={'medium'}
                      text={t(`${box.highlightKey}`)}
                    />
                  ),
                }}
              />
            </div>
          </div>
        ))}
      </section>
      <Button className={styles.button} onClick={handleOpenAddressBook}>
        {t('why-glovo.button.text')}
      </Button>
      <AddressBookModal
        isOpen={isOpenAddressBook}
        onClose={handleCloseAddressBook}
        onSelect={handleAddressSelect}
      />
    </article>
  )
}
